import React, { useRef, useState } from "react";

import { DRAG_AND_DROP_DOCUMENT_HERE } from "Constant";

import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";
import { ProgressBar } from "primereact/progressbar";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Tag } from "primereact/tag";

import CancelModalBtn from "Components/ModalApp/CancelModalBtn";
import Translate from "Components/Translate";

import { useDispatch, useSelector } from "react-redux";
import { toggleRefresh } from "../../redux/searchLink";
import { toggleModal } from "../../redux/modal";

import patchData from "Services/patchData";

const UploadAvatar = ({ fileName }) => {
  const { getLink } = useSelector((state) => state.currentRow);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const addedWithSuccess = () => {
    dispatch(toggleRefresh());
    dispatch(toggleModal());
  };

  const toast = useRef(null);
  const [totalSize, setTotalSize] = useState(0);
  const fileUploadRef = useRef(null);

  const onTemplateSelect = (e) => {
    let _totalSize = totalSize;
    let files = e.files;

    Object.keys(files).forEach((key) => {
      _totalSize += files[key].size || 0;
    });

    setTotalSize(_totalSize);
  };

  const onTemplateUpload = (e) => {
    let _totalSize = 0;

    e.files.forEach((file) => {
      _totalSize += file.size || 0;
    });

    setTotalSize(_totalSize);
    toast.current.show({
      severity: "info",
      summary: "Success",
      detail: "File Uploaded",
    });
  };

  const onTemplateRemove = (file, callback) => {
    setTotalSize(totalSize - file.size);
    callback();
  };

  const headerTemplate = (options) => {
    const { className, chooseButton } = options;
    const value = totalSize / 10000;
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? fileUploadRef.current.formatSize(totalSize)
        : "0 B";

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}

        <div className="flex align-items-center gap-3 ml-auto">
          <span>{formatedValue}</span>
          <ProgressBar
            value={value}
            showValue={false}
            style={{ width: "10rem", height: "12px" }}
          ></ProgressBar>
        </div>
      </div>
    );
  };

  const itemTemplate = (file, props) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={100}
          />
          <span className="flex flex-column text-left ml-3">
            {file.name}
            <small>{new Date().toLocaleDateString()}</small>
          </span>
        </div>
        <Tag
          value={props.formatSize}
          severity="warning"
          className="px-3 py-2"
        />
        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    );
  };

  const emptyTemplate = () => {
    return (
      <div className="flex align-items-center flex-column">
        <i
          className="pi pi-image mt-3 p-5"
          style={{
            fontSize: "5em",
            borderRadius: "50%",
            backgroundColor: "var(--surface-b)",
            color: "var(--surface-d)",
          }}
        ></i>
        <span
          style={{ fontSize: "1.2em", color: "var(--text-color-secondary)" }}
          className="my-5"
        >
          <Translate>{DRAG_AND_DROP_DOCUMENT_HERE}</Translate>
        </span>
      </div>
    );
  };

  const chooseOptions = {
    icon: "pi pi-fw pi-images",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
  };
  const uploadOptions = {
    icon: "pi pi-fw pi-cloud-upload",
    iconOnly: true,
    className:
      "custom-upload-btn p-button-success p-button-rounded p-button-outlined",
  };
  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className:
      "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
  };

  const handleSubmit = () => {
    const uploadedFiles = fileUploadRef.current.getFiles();
    if (!uploadedFiles || uploadedFiles.length === 0) {
      console.log("No file selected");
      return;
    }

    const file = uploadedFiles[0];
    const reader = new FileReader();

    reader.onload = () => {
      // Convert the image to Base64
      const base64String = reader.result;

      // Prepare the payload
      const payload = {
        avatar: base64String,
      };

      console.log("Payload to send:", payload);

      setIsLoading(true);

      // Send the payload using patchData
      console.log(payload);

      patchData(payload, getLink, setIsLoading, addedWithSuccess);
    };

    // Read the file as a Base64 string
    reader.readAsDataURL(file);
  };

  return (
    <div>
      <Toast ref={toast}></Toast>

      <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
      <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
      <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

      <FileUpload
        ref={fileUploadRef}
        name="demo[]"
        url="/api/upload"
        multiple
        accept="image/*"
        maxFileSize={null} // Remove file size limit
        onUpload={onTemplateUpload}
        onSelect={onTemplateSelect}
        headerTemplate={headerTemplate}
        itemTemplate={itemTemplate}
        emptyTemplate={emptyTemplate}
        chooseOptions={chooseOptions}
        uploadOptions={uploadOptions}
        cancelOptions={cancelOptions}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "1%",
          padding: "5px",
        }}
      >
        <CancelModalBtn />
        <Button
          disabled={!fileUploadRef.current}
          type="submit"
          label="Go"
          severity="success"
          loading={isLoading}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default UploadAvatar;
